// SQL identifier naming rules — a bare **lowercase** identifier: starts with a
// letter or underscore, then lowercase letters/digits/underscores only (no
// uppercase, spaces, dashes, dots or quoting), capped at 64 chars (MySQL's
// limit; Postgres truncates at 63).
//
// Extracted from the copies in data-structure-page company-fields/CreateCompanyFieldModal
// and option-sets/CreateOptionSetModal
// once a third caller (the Data setup DB-name cell) needed it; new callers use
// this. It returns WHICH RULE broke rather than an i18n key, so each module
// keeps its own wording — the rule is shared, the copy is not.
//
// Lives here rather than in the API layer so the user is told before any
// request is made.

export const SQL_IDENTIFIER_RE = /^[a-z_][a-z0-9_]*$/;
export const SQL_IDENTIFIER_MAX = 64;

export type SqlIdentifierError = 'required' | 'too_long' | 'invalid';

/** The first rule the value breaks, or null when it's valid. */
export const sqlIdentifierError = (value: string): SqlIdentifierError | null => {
  const v = value.trim();
  if (!v) return 'required';
  if (v.length > SQL_IDENTIFIER_MAX) return 'too_long';
  if (!SQL_IDENTIFIER_RE.test(v)) return 'invalid';
  return null;
};

export default sqlIdentifierError;
